import styled from 'styled-components';
import { connect } from 'react-redux';
import * as modalActions from 'components/common/modal/modal-actions';
import { useTranslations } from 'hooks';
import { Row, Col } from 'components/common/grid';
import { Button } from 'components/common/buttons';
import PropTypes from 'prop-types';
import { Icon } from 'components/common/icon/icon';

const StyledButton = styled(Button)`
  margin: 0 5px;
  min-width: 90px;
`;

const Text = styled(Col)`
  text-align: center;
  font-family: ${props => props.theme.fonts.montserratMedium};
  overflow-wrap: break-word;
`;

const BigText = styled(Col)`
  text-align: center;
  font-size: 2rem;
  font-family: ${props => props.theme.fonts.montserratMedium};
  overflow-wrap: break-word;
`;

const StyledIcon = styled(Icon)`
  margin: 0 46px;
  color: ${props => props.theme.colors.green};
  font-size: 8.5rem;
`;

const Wrapper = styled.div`
  text-align: center;
`;

export const SuccessModal = ({
  onConfirm,
  closeModal,
  message,
  buttonText,
  closeOnConfirm = true,
  green = false,
  ids,
  children,
  bigText
}) => {
  const TRANSLATION_TEXT = useTranslations();

  const onConfirmClick = () => {
    if (onConfirm) {
      onConfirm();
    }
    if (closeOnConfirm) {
      closeModal();
    }
  };

  return (
    <Wrapper>
      <Row justifyCenter>
        <Col xs={100}>
          <StyledIcon name="checkCircle" />
        </Col>
      </Row>
      <Row justifyCenter>
        {bigText && (
          <BigText marginTop={25} marginBottom={25} xs={100}>
            {bigText}
          </BigText>
        )}
        {(message || children) && (
          <Text marginTop={25} marginBottom={25} xs={100}>
            {message || children}
          </Text>
        )}
      </Row>
      <Row justifyCenter>
        <StyledButton blue={!green} green={green} onClick={onConfirmClick} ids={ids}>
          {buttonText || TRANSLATION_TEXT.ok_upper_case}
        </StyledButton>
      </Row>
    </Wrapper>
  );
};

SuccessModal.propTypes = {
  onConfirm: PropTypes.func,
  closeModal: PropTypes.func,
  message: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  closeOnConfirm: PropTypes.bool,
  buttonText: PropTypes.string,
  green: PropTypes.bool,
  ids: PropTypes.array,
  children: PropTypes.node,
  bigText: PropTypes.string
};

export default connect(null, {
  closeModal: modalActions.closeModal
})(SuccessModal);
